import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import logo from "../../assets/images/Logo.svg";
import Modal from "../../components/Modal";
import ServiceValue from "../SignUp/ServiceValue/ServiceValue";
import { postLogin, cancelProject } from "../../utils/api";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email is required"),
      password: Yup.string()
        // .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await postLogin(values);
        handleReturnToPreviousUser();

        if (res.data.success) {
          const data = res.data?.data;

          if (data) {
            localStorage.setItem("userData", JSON.stringify(data));
            localStorage.setItem("showWelcomeOnDashboard", "true");
            
            // Call cancelProject after successful login
            try {
              await cancelProject(data.access_token);
            } catch (error) {
              console.error("Error canceling project after login:", error);
            }
          }

          setModalMessage("Login successful! Welcome aboard.");
          setIsError(false);
          setIsModalOpen(true);

          setTimeout(() => {
            setIsModalOpen(false);
            navigate("/dashboard");
          }, 2000);
        }
      } catch (error) {
        setModalMessage(
          error.response?.data?.message ||
            "An error occurred. Please try again.",
        );
        setIsError(true);
        setIsModalOpen(true);
      }
    },
  });
  const handleReturnToPreviousUser = () => {
    const previousUserData = JSON.parse(
      localStorage.getItem("previousUserData"),
    );
    if (previousUserData) {
      localStorage.setItem("userData", JSON.stringify(previousUserData));
      localStorage.removeItem("previousUserData");
    }
  };
  return (
    <div className="h-screen w-full sign-up flex items-center justify-center flex-col md:flex-row">
      <div className="w-full h-full flex items-center justify-center md:pt-0 pt-10 md:pb-0 pb-10">
        <div className="flex flex-col items-start gap-[50px]">
          <header className="inline-flex flex-col items-start justify-center gap-[50px] md:gap-[100px] flex-[0_0_auto] bg-transparent">
            <img
              className="w-[170.41px] h-[26.57px] ml-8"
              alt="Logo"
              src={logo}
            />
            <div className="inline-flex flex-col items-start justify-center gap-[5px] flex-[0_0_auto] px-4 -my-10">
              <p className="w-fit mt-[-1.00px] [font-family:'Inter-SemiBold',Helvetica] font-semibold text-white text-[32px] tracking-[0] leading-[48px]">
                Great! Now Let&apos;s Get Some Info
              </p>
              <p className="w-fit [font-family:'Inter-Medium',Helvetica] font-medium text-[#e0e0e0] text-[15px] tracking-[0] leading-[22.5px]">
                Please fill in the fields below to log in to your account.
              </p>
            </div>
          </header>
          <form
            onSubmit={formik.handleSubmit}
            className="gap-[25px] self-stretch w-full flex flex-col items-start flex-[0_0_auto] px-4"
          >
            <div className="gap-3 self-stretch w-full flex flex-col items-start flex-[0_0_auto]">
              <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto]">
                <label className="w-fit mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]">
                  Email
                </label>
                <input
                  name="email"
                  className="max-w-[513px] w-full px-[22px] py-[18px] bg-[#0d2c3b] rounded-md border border-solid border-[#444444] mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]"
                  placeholder="example@gmail.com"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="gap-3 self-stretch w-full flex flex-col items-start flex-[0_0_auto]">
              <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto]">
                <label className="w-fit mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]">
                  Password
                </label>
                <input
                  name="password"
                  className="max-w-[513px] w-full px-[22px] py-[18px] bg-[#0d2c3b] rounded-md border border-solid border-[#444444] mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]"
                  placeholder="•••••••••••••••••••••••"
                  type="password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="flex justify-between w-full">
              <div className="flex items-center">
                <input type="checkbox" value="" id="invalidCheck" required="" />
                <label
                  className="text-white text-[12px] pl-[5px]"
                  htmlFor="invalidCheck"
                >
                  Remember me
                </label>
              </div>
              <a
                href="/password/reset"
                className="text-[#3490DE] text-[12px] font-bold"
              >
                Forgot your password?
              </a>
            </div>

            <div className="flex flex-col items-start gap-[25px] self-stretch w-full flex-[0_0_auto]">
              <button
                type="submit"
                className="all-[unset] box-border flex items-center justify-center gap-2.5 px-[10px] py-3.5 self-stretch w-full flex-[0_0_auto] rounded-[5px] [background:linear-gradient(180deg,rgb(254,100,50)_0%,rgb(248,118,31)_100%)]"
              >
                <span className="w-fit mt-[-1.00px] [font-family:'Inter-SemiBold',Helvetica] font-semibold text-white text-sm tracking-[0] leading-[21px]">
                  Login
                </span>
              </button>
            </div>
            <div className="flex justify-start text-center w-full">
              
              <a
                href="/registration"
                className="text-white text-base font-bold"
              >
                <span className="text-[rgb(254,100,50)] underline text-base font-bold">
                Register here
                </span> to avail our services !
              </a>
            </div>
          </form>

          {isModalOpen && (
            <Modal
              message={modalMessage}
              isError={isError}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      </div>
      <div className="w-full min-h-[100vh] flex items-center justify-center bg-[#001522] md:pt-0 pt-10 md:pb-0 pb-10">
        <ServiceValue />
      </div>
    </div>
  );
};

export default Login;
